module.exports = __webpack_public_path__ + "static/media/styledmenu-close.e91d2903.svg";